// import axios from 'axios';
// import { PublicClientApplication, AuthenticationResult } from '@azure/msal-browser';
// import { msalConfig, loginRequest } from '../config/msalConfig';
// const apiClient = axios.create({
//   baseURL: 'https://your-api-url.com/api', // Your backend API URL
// });

// const msalInstance = new PublicClientApplication(msalConfig);

// // Add a request interceptor to inject the authorization header
// apiClient.interceptors.request.use(async (config) => {
//     const account = msalInstance.getActiveAccount();
//     if (!account) {
//         throw new Error("No active account! Please log in.");
//     }

//     // Try to get token silently
//     const response: AuthenticationResult = await msalInstance.acquireTokenSilent({
//         ...loginRequest, // Use the same scopes defined earlier, or new ones
//         account: account,
//     });

//     if (response.accessToken) {
//       config.headers['Authorization'] = `Bearer ${response.accessToken}`;
//     }

//     return config;
// }, (error) => {
//     return Promise.reject(error);
// });

// export default apiClient;

// import axios from 'axios';
// // Import the single, shared MSAL instance and API scopes
// import { msalInstance, apiScopes } from '../config/msalConfig'; 
// import { AuthenticationResult } from '@azure/msal-browser';

// const apiClient = axios.create({
//     baseURL: 'http://localhost:5000/api', // Your backend API URL
// });

// apiClient.interceptors.request.use(async (config) => {
//     const account = msalInstance.getActiveAccount();
//     if (!account) {
//         throw new Error("No active account! Please log in.");
//     }

//     try {
//         const response: AuthenticationResult = await msalInstance.acquireTokenSilent({
//             scopes: apiScopes.scopes, // Use the correct scope property
//             account: account,
//         });

//         if (response.accessToken) {
//             config.headers['Authorization'] = `Bearer ${response.accessToken}`;
//         }
//     } catch (error) {
//         console.error("Error acquiring access token silently:", error);
//         throw error;
//     }

//     return config;
// }, (error) => {
//     return Promise.reject(error);
// });

// export default apiClient;

// src/services/apiClient.ts

// import axios from 'axios';
// import { msalInstance, apiScopes } from '../config/msalConfig'; 
// import { AuthenticationResult } from '@azure/msal-browser';

// const apiClient = axios.create({
//     baseURL: 'http://localhost:5000/api',
// });

// apiClient.interceptors.request.use(async (config) => {
//     // Add a check for msalInstance being null
//     if (!msalInstance) {
//         throw new Error("MSAL instance is not initialized.");
//     }

//     const account = msalInstance.getActiveAccount();
//     if (!account) {
//         throw new Error("No active account! Please log in.");
//     }

//     try {
//         console.log('%c[DEBUG] Acquiring token with scopes:', 'color: blue; font-weight: bold;', apiScopes.scopes);
//         const response: AuthenticationResult = await msalInstance.acquireTokenSilent({
//             scopes: apiScopes.scopes,
//             account: account,
//         });
//         // =================================================================
//         // == DEBUG LOGGING: This will show us the token that was acquired.
//         // =================================================================
//         console.log('%c[DEBUG] Acquired Token:', 'color: green; font-weight: bold;', response.accessToken);
//         // =================================================================

//         if (response.accessToken) {
//             config.headers['Authorization'] = `Bearer ${response.accessToken}`;
//         }
//     } catch (error) {
//         console.error("Error acquiring access token silently:", error);
//         throw error;
//     }

//     return config;
// }, (error) => {
//     return Promise.reject(error);
// });

// export default apiClient;
// src/services/apiClient.ts

import axios from 'axios';
import { msalInstance, apiScopes } from '../config/msalConfig'; 
import { AuthenticationResult } from '@azure/msal-browser';

const apiClient = axios.create({
    baseURL: 'http://localhost:5000/api',
});

// This interceptor runs BEFORE every API request is sent.
apiClient.interceptors.request.use(async (config) => {
    if (!msalInstance) {
        throw new Error("MSAL instance is not initialized.");
    }

    const account = msalInstance.getActiveAccount();
    if (!account) {
        throw new Error("No active account! Please log in.");
    }

    try {
        console.log('%c[API Client] Attempting to acquire access token silently...', 'color: blue;');
        
        // 1. Attempt to get the token from MSAL
        const response: AuthenticationResult = await msalInstance.acquireTokenSilent({
            scopes: apiScopes.scopes,
            account: account,
        });

        // 2. If successful, LOG THE TOKEN IMMEDIATELY.
        console.log('%c[API Client] Access Token Acquired:', 'color: green; font-weight: bold;', response.accessToken);
        
        // 3. Attach the token to the request headers.
        config.headers['Authorization'] = `Bearer ${response.accessToken}`;

    } catch (error) {
        // This block runs ONLY if getting the token from Microsoft fails.
        console.error('%c[API Client] FAILED to acquire access token.', 'color: red; font-weight: bold;', error);
        // Re-throw the error to stop the API call from proceeding without a token.
        throw error;
    }

    // 4. Return the modified config to proceed with the network request.
    // This happens AFTER the token has been acquired and logged.
    return config;
}, (error) => {
    return Promise.reject(error);
});

export default apiClient;